import {
    Input,
    Component,
    Output,
    EventEmitter,
    Inject
} from '@angular/core';

import { TOAST_DATA } from '../toastr.service';

@Component({
    selector: 'app-toast-success-access-key',
    templateUrl: './toast-success-access-key.component.pug',
    styleUrls: ['./toast-success-access-key.component.less'],
})
export class ToastSuccessAccessKeyComponent {
    constructor(
        @Inject(TOAST_DATA) public data: any
    ) {
    }
}
